// Removed all TypeScript imports

export const InteractionType = {
  TrueFalse: 1,
  FillInTheBlanks: 2,
  MultiChoice: 3,
  DragDrop: 4,
  HintInfo: 5,
  DragWords: 6,
  SingleChoice: 7,
};

export const Multiple_Choice_Question_Type = {
  Multiple: 1,
  Single: 2
};

export const VideoInteractionStatus = {
  Todo: 1,
  InProgress:2,
  PendingReview: 3,
  Rejected: 4,
  Approved: 5,
  HasError:6
};

function toSeconds(value) {
  if (!value) return 0;
  return Math.max(0, Number(value.toFixed(3)));
}

function parseFillBlanks(interaction) {
  const source =
    (interaction.templateText && interaction.templateText.trim()) ||
    interaction.prompt ||
    "";

  const markerRegex = /\*([^*]+)\*/g;
  const blanks = [];

  for (const match of source.matchAll(markerRegex)) {
    const answers = (match[1] || "")
      .split("|")
      .map(function (v) {
        return v.trim();
      })
      .filter(Boolean);

    if (answers.length > 0) {
      blanks.push(answers);
    }
  }

  if (blanks.length === 0 && Array.isArray(interaction.acceptedAnswers)) {
    const legacy = interaction.acceptedAnswers
      .map(function (v) {
        return v.trim();
      })
      .filter(Boolean);

    if (legacy.length > 0) {
      blanks.push(legacy);
    }
  }

  return { templateText: source, blanks: blanks };
}

function normalizeMultipleChoice(interaction) {
  if (Array.isArray(interaction.options) && interaction.options.length > 0) {
    return {
      questionType:
        interaction.selectionMode === "multiple"
          ? Multiple_Choice_Question_Type.Multiple
          : Multiple_Choice_Question_Type.Single,

      options: interaction.options.map(function (opt) {
        return {
          optionText: opt.text || "",
          correctAnswer: Boolean(opt.isCorrect),
          tipText: opt.tipText || "",
          messageIfSelected: opt.selectedFeedback || "",
          messageIfNotSelected: opt.unselectedFeedback || ""
        };
      })
    };
  }

  const legacyChoices = interaction.choices || [];
  const legacyCorrectIndex =
    typeof interaction.correctIndex === "number"
      ? interaction.correctIndex
      : 0;

  return {
    questionType: Multiple_Choice_Question_Type.Single,
    options: legacyChoices.map(function (text, idx) {
      return {
        optionText: text,
        correctAnswer: idx === legacyCorrectIndex,
        tipText: "",
        messageIfSelected: "",
        messageIfNotSelected: ""
      };
    })
  };
}

function mapMedia(interaction) {
  return {
    BgImage:
      (interaction.backgroundImageUrl &&
        interaction.backgroundImageUrl.trim()) ||
      "",
    Media:
      (interaction.exampleImageUrl &&
        interaction.exampleImageUrl.trim()) ||
      ""
  };
}

function mapCommon(interaction, id) {
  return Object.assign(
    {
      id: id,
      StartTimeSec: toSeconds(interaction.timeSec),
      Position: interaction.position
    },
    mapMedia(interaction)
  );
}

function mapDragWordsData(interaction) {
  if (!interaction) return {};

  const template = interaction.sentenceTemplate || "";

  const distractorWords = interaction.distractorWords || [];

  const correctWords =
    interaction.correctWords && interaction.correctWords.length > 0
      ? interaction.correctWords
      : Array.from(template.matchAll(/\*([^*]+)\*/g))
          .map(function (m) {
            return (m[1] || "").trim();
          })
          .filter(Boolean);

  return {
    Question: interaction.prompt,
    QuestionText: template,
    CorrectWords: correctWords.map(function (label, index) {
      return {
        Id: index + 1,
        Label: label
      };
    }),
    Distractors: distractorWords.map(function (label, index) {
      return {
        Id: correctWords.length + index + 1,
        Label: label
      };
    }),
    // Interchangeable blank groups (order-independent); array of blank-index
    // arrays. Absent/empty means every blank is position-locked.
    BlankGroups: interaction.blankGroups || [],
    FeedBackOnWrongAnswer:interaction.revealText || "",
    EnableRetry: interaction.enableRetry ?? true,
    ShowSolution: interaction.showSolution ?? true
  };
}

export function mapInteraction(interaction, id) {
  if (!interaction || !interaction.type) {
    return null;
  }
  const common = mapCommon(interaction, id);

  if (interaction.type === "true_false") {
    return Object.assign({}, common, {
      type: InteractionType.TrueFalse,
      QuestionText: interaction.prompt,
      FeedBackOnCorrectAnswer: interaction.revealText || "",
      FeedBackOnWrongAnswer: interaction.revealText || "",
      ShowSolution: true,
      CorrectAnswer: interaction.correct
    });
  }

  if (interaction.type === "fill_blank") {
    const fillData = parseFillBlanks(interaction);

    return Object.assign({}, common, {
      type: InteractionType.FillInTheBlanks,
      QuestionText: interaction.prompt,
      TaskDescription: "Boşlukları uygun kelimelerle doldurun.",
      FeedBackOnCorrectAnswer: interaction.revealText || "",
      FeedBackOnWrongAnswer: interaction.revealText || "",
      EnableRetry: interaction.enableRetry ?? true,
      ShowSolution: interaction.showSolution ?? true,
      CaseSensitive: false,
      TemplateText: fillData.templateText,
      Blanks: fillData.blanks
    });
  }

  if (interaction.type === "multiple_choice") {
    const mc = normalizeMultipleChoice(interaction);
    if(mc.questionType === Multiple_Choice_Question_Type.Single){
      return Object.assign({}, common, {
        type: InteractionType.SingleChoice,
        QuestionText: interaction.prompt,
        FeedBackOnWrongAnswer:interaction.revealText || "",
        Options: mc.options,
        EnableRetry: interaction.enableRetry ?? true,
        ShowSolution: interaction.showSolution ?? true,
        QuestionType: mc.questionType
      });
    }else
    return Object.assign({}, common, {
      type: InteractionType.MultiChoice,
      QuestionText: interaction.prompt,
      Options: mc.options,
      EnableRetry: interaction.enableRetry ?? true,
      ShowSolution: interaction.showSolution ?? true,
      QuestionType: mc.questionType,
      FeedBackOnWrongAnswer:interaction.revealText || "",
    });
  }

  if (interaction.type === "drag_drop") {
    const dropZones = (interaction.slots || []).map(function (label, zoneIdx)  {
      return {
        Label: label,
        Id: zoneIdx + 1
      };
    });

    const dropElements = (interaction.items || []).map(function (label, itemIdx) {
      // Every zone this element is a correct answer for. With AllowReuse an
      // element can belong to several zones; otherwise it's just one.
      const zoneIds = (interaction.correctBySlot || [])
        .map(function (zoneItems, zoneIdx) {
          return zoneItems.includes(itemIdx) ? zoneIdx + 1 : null;
        })
        .filter(function (v) {
          return v !== null;
        });

      return {
        Label: label,
        Id: itemIdx + 1,
        // Back-compat single zone (first) + the full multi-zone list.
        DropZoneId: zoneIds.length > 0 ? zoneIds[0] : 0,
        DropZoneIds: zoneIds
      };
    });

    return Object.assign({}, common, {
      type: InteractionType.DragDrop,
      QuestionText: interaction.prompt,
      DropZone: dropZones,
      DropElements: dropElements,
      AllowReuse: Boolean(interaction.allowReuse),
      FeedBackOnWrongAnswer:interaction.revealText || "",
      EnableRetry: interaction.enableRetry ?? true,
      ShowSolution: interaction.showSolution ?? true
    });
  }

  if (interaction.type === "info_hint") {
    return Object.assign({}, common, {
      type: InteractionType.HintInfo,
      Text: interaction.prompt,
      EndTimeSec: toSeconds(
        interaction.timeSec + (interaction.durationSec || 0)
      )
    });
  }

  return Object.assign({}, common, {
    type: InteractionType.DragWords
  }, mapDragWordsData(interaction));
}

export function mapProjectToBackendPayload(project) {
  const interactions = project.interactions
    .slice()
    .sort(function (a, b) {
      return a.timeSec - b.timeSec;
    })
    .map(function (interaction, index) {
      return mapInteraction(interaction, index + 1);
    })
    .filter(Boolean);

  return {
    VideoTitle: project.title,
    VideoUrl: project.videoUrl,
    Interactions: interactions
  };
}
